














































































import { Component, Vue } from 'vue-property-decorator';
import SectionWrapper from '@/componentsV2/molecules/SectionWrapper/SectionWrapper.vue';
import PerformanceItem from '@/components/molecules/PerformanceItem/PerformanceItem.vue';
import {
  CustomSelectGroup,
  CustomSelectModel,
  CustomSelectOption
} from '@/components/CustomSelect/CustomSelectModel';
import CustomSelect from '@/components/CustomSelect/CustomSelect.vue';
import SectionData from '@/componentsV2/organisms/SectionData/SectionData.vue';
import { appIsActive } from '@/router/validators/utils';
import { EBusinessReportType } from '@/models/business';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import DropDownLocations from '@/componentsV2/molecules/DropDownLocations/DropDownLocations.vue';
import PerformanceConversionsService from '@/api/PerformanceConversionsService';

@Component({
  components: {
    SectionWrapper,
    SectionData,
    PerformanceItem,
    CustomSelect,
    Typography,
    DropDownLocations
  }
})
export default class PerformanceRedemptionOverview extends Vue {
  performanceConversionsService = new PerformanceConversionsService();

  observer: IntersectionObserver | null = null;
  triggerIntersected = false;

  redemptionTypeActive: string = EBusinessReportType.OFFER_COINS;
  locationsActive: any[] = [];

  totalValues: Record<string, any> = {
    totalRedemptions: {
      counter: 0
    },
    paymentRelatedToRedemptions: {
      counter: 0,
      prefixCounter: '',
      counterFractionDigits: 2
    },
    averagePaymentRelatedToRedemptions: {
      counter: 0,
      prefixCounter: '',
      counterFractionDigits: 2,
      infoIconTooltip:
        'The average spend reflects redemptions that are linked to transactions. If multiple redemptions occur with a single transaction, this value may vary.',
      showInfoIcon: true
    }
  };

  get tPrefix() {
    return `performance.redemptions.overview`;
  }

  get configSection() {
    return {
      descriptionMaxWidth: '684px',
      titleFontSize: '18px',
      padding: this.$mobileCheck() ? '24px' : '32px 24px'
    };
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessState'];
  }

  get disabledRedemptionFilter() {
    return this.businessInfo.reportType !== EBusinessReportType.OFFER_COINS;
  }

  get showFilters() {
    return appIsActive();
  }

  get filterRedemptionType() {
    const options: CustomSelectOption[] = [];

    if (this.showOfferFilter)
      options.push(new CustomSelectOption('offer', `Offers`, true));

    if (this.showCoinFilter)
      options.push(new CustomSelectOption('coin', `Coins`, true));

    const actionGroup = new CustomSelectGroup(options);

    return new CustomSelectModel(
      [actionGroup],
      `Offers and Coins`,
      false,
      true,
      true,
      true
    );
  }

  get currencySymbol() {
    return this.$store.getters['internationalization/getCountrySettings']
      .currencySymbol;
  }

  get transformedTotalValues() {
    const result = Object.entries(this.totalValues).map(([key, value]) => ({
      ...value,
      ...(value.hasOwnProperty('prefixCounter') && {
        prefixCounter: this.currencySymbol
      }),
      label: String(
        this.$t(
          `${this.tPrefix}.cards.${this.redemptionTypeActive}.${key}.label`
        )
      ),
      slug: key,
      description: String(
        this.$t(
          `${this.tPrefix}.cards.${
            this.redemptionTypeActive
          }.${key}.description`
        )
      )
    }));

    return result;
  }

  get showOfferFilter() {
    return (
      this.businessInfo.reportType === EBusinessReportType.OFFER ||
      this.businessInfo.reportType === EBusinessReportType.OFFER_COINS
    );
  }

  get showCoinFilter() {
    return (
      this.businessInfo.reportType === EBusinessReportType.COIN ||
      this.businessInfo.reportType === EBusinessReportType.OFFER_COINS
    );
  }

  async loadOverview() {
    try {
      this.$showLoader();

      const filters: any = {};
      let locations = [];

      if (this.redemptionTypeActive !== EBusinessReportType.OFFER_COINS)
        filters.redemptionType = this.redemptionTypeActive;

      if (
        this.businessInfo.businessLocations.length !==
        this.locationsActive.length
      ) {
        locations = this.locationsActive;
      }

      const response = await this.performanceConversionsService.getOverview(
        filters,
        locations
      );

      if (response.status !== 200) return;

      const dataToUpdate = Object.keys(this.totalValues);

      const entries = Object.entries(response.data);

      let newTotalValues = this.totalValues;

      for (const entry of entries) {
        const [key, value] = entry;

        if (!dataToUpdate.includes(key)) continue;

        const totalValue = newTotalValues[key];

        Object.assign(totalValue, {
          counter: value,
          disabled: Number(value) === 0
        });
      }
      this.totalValues = newTotalValues;
    } finally {
      this.$hideLoader();
    }
  }

  getRedemptionTypeActive() {
    const redemptionTypesActive = this.filterRedemptionType.groups[0].options.filter(
      item => item.isSelected
    );

    if (
      redemptionTypesActive.length === 2 ||
      redemptionTypesActive.length === 0
    )
      return EBusinessReportType.OFFER_COINS;

    return redemptionTypesActive[0].uuid;
  }

  changedRedemptionType() {
    this.redemptionTypeActive = this.getRedemptionTypeActive();
    this.loadOverview();
  }

  changedLocations(items: CustomSelectOption[]) {
    this.locationsActive = items.map(item => ({ ...item, id: item.uuid }));
    this.loadOverview();
  }

  created() {
    this.redemptionTypeActive = this.getRedemptionTypeActive();
    this.loadOverview();
  }

  mounted() {
    this.handleTriggerObserver();
  }

  beforeDestroy() {
    if (this.observer) this.observer.disconnect();
  }

  handleTriggerObserver() {
    if (!this.$mobileCheck()) return;

    const target = document.querySelector(
      '.performance-redemption-overview__grid-trigger'
    );

    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.triggerIntersected = entry.isIntersecting;
      },
      {
        root: document.querySelector('.performance-redemption-overview__grid'),
        threshold: 0
      }
    );

    this.observer.observe(target as HTMLElement);
  }
}
